import useSWR from 'swr-0-5-6';
import { apirc } from '~/configs/apirc';
const ROOT_URL = apirc.unclassified.tradingSummary.baseUrl;
export const PROPORTION_NAMES = [
    ['指數期貨', '指數類'],
    ['股票期貨', '利率類'],
    ['選擇權', '匯率類'],
    '債券類',
    '個股類',
    '穀物類',
    '金屬類',
    '能源類',
    '期貨類',
];
/** 客戶收益率 */
export const useReturnRate = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/returnRate?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶勝率 */
export const useWinRate = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/winRate?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶平均每口賺賠比表格 */
export const useProfitFactorPerLot = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/profitFactorPerLot?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶賺賠比表格 */
export const useProfitFactor = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/profitFactor?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶最大回測率 */
export const useMaxDrawdown = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/maxDrawdown?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶平均風險指標 */
export const useRiskIndicator = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/riskIndicator?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶交易商品比重 */
export const useCommodityProportion = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/commodityProportion?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶交易頻率 */
export const useFrequency = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/frequency?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶持倉時間 */
export const usePositionDuration = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/positionDuration?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 客戶前三大盈虧 */
export const useTop3PnL = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/top3PnL?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 區間內每日客戶收益率、大盤漲跌幅、期顧收益率 */
export const useDailyReturnRate = (token, id, account, since) => {
    const res = useSWR(account && token
        ? [`${ROOT_URL}/dailyReturnRate?id=${id}&accountNo=${account}&sinceWhen=${since}`, token]
        : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 區間內期顧代表五項數值分析之富邦排行比 */
export const useFuturesAdviserPerformanceRanking = (token, since) => {
    const res = useSWR(since ? [`${ROOT_URL}/futuresAdviserPerformanceRanking?sinceWhen=${since}`, token] : null, fetcherWithToken, { shouldRetryOnError: false, errorRetryCount: 0 });
    return {
        data: res.data,
    };
};
/** 透過`身分證字號`取得該客戶底下所有的帳戶資訊 */
export const useAccountInfo = (token, id) => {
    const res = useSWR(token && id ? [`${ROOT_URL}/accountInfo?id=${id}`, token] : null, fetcherWithToken, {
        shouldRetryOnError: false,
        errorRetryCount: 0,
    });
    return res;
};
export const fetcherWithToken = async (url, token) => {
    return fetch(url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }).then(res => {
        if (res.status !== 200) {
            return null;
        }
        return res.json();
    });
};
